import getActionsByDocument from '../../../../components/comments/actions';

const DOCUMENT = 'AGENCY_COMMENTS_';

export default getActionsByDocument(DOCUMENT);
